export default "__VITE_ASSET__2EeHOM1r__"